import './demopopup.less'

import {classes, Icon} from '@codeurs/front'
import {DemosItemType} from 'pages/demos/demos'
import React, {useEffect, useRef, useState} from 'react'
import {style} from 'util/style'

const styles = style('demopopup')

export const DemoPopup: React.FC<{
	demo: DemosItemType
	onClose: () => void
	setVertical: (vertical: string) => void
	theme: string
	light: boolean
}> = ({demo, onClose, setVertical, theme, light}) => {
	const [readmore, setReadmore] = useState('')
	const popupRef: any = useRef(null)

	useEffect(() => {
		if (demo) {
			const descriptionElement = document.createElement('div')
			descriptionElement.innerHTML = demo.description
			const paragraphs = descriptionElement.querySelectorAll('p')
			setReadmore(paragraphs.length > 1 ? 'readmore' : '')
		}

		if (demo && popupRef.current) {
			const popup = popupRef.current
			const container = popup.parentNode
			const target = document.getElementById(demo.floorplan_id)

			const cr = container.getBoundingClientRect()
			const tr = target.getBoundingClientRect()

			const top = tr.top - cr.top + tr.height + 5
			if (tr.left > window.innerWidth / 2) {
				const right = cr.left + cr.width - (tr.left + tr.width) - 25

				popup.style.top = `${top}px`
				popup.style.left = `inherit`
				popup.style.right = `${right}px`
			} else {
				const left = tr.left - cr.left - 25

				popup.style.top = `${top}px`
				popup.style.left = `${left}px`
				popup.style.right = `inherit`
			}
		}
	}, [demo, setVertical])

	if (!demo) return

	const {title, demo_labels, description} = demo

	return (
		<div
			ref={popupRef}
			{...classes(`demopopup theme-${theme}`, {
				mod: readmore,
				is: {light}
			})}
		>
			<h3 className={styles('title')}>{title}</h3>
			{demo_labels &&
				demo_labels.length > 0 &&
				demo_labels.map(tag => (
					<a
						className={styles('tag')}
						onClick={() => setVertical(tag.id.toString())}
					>
						{tag.title}
					</a>
				))}
			<div className={styles('description')}>
				<div
					className="wysiwyg"
					dangerouslySetInnerHTML={{__html: description}}
				/>
			</div>
			<a className={styles('readmore')} onClick={() => setReadmore('')}>
				Read more...
			</a>
			<a className={styles('close')} onClick={onClose}>
				<Icon icon="close" />
			</a>
		</div>
	)
}
